import React from 'react';
import PlanPanelsBlock from './PlanPanelsBlock';
import PricingPlansInfo from '../PricingPlansInfo';
import styles from '../styles.scss';

const PricingPlansPanel = () => (
  <div className={ styles.pricingPanelContainer }>
    <div className={ styles.pricingHeader }>
      <div className={ styles.pricingHeaderTitle }>
        Industry Leading Fixed Income Primary Market Data
      </div>
      <div className={ styles.pricingHeaderDescription }>
        Finsight.com is an award-winning fixed income primary and secondary market data service used by tens
        of thousands of capital markets professionals. Gathered at the source, our datasets are among the cleanest,
        most comprehensive, and most accurate in the industry. Access modules that provide deep visibility
        into new issue volumes, pricing,<br />league tables and more.
      </div>
    </div>

    <PlanPanelsBlock />
    <PricingPlansInfo />
  </div>
);

export default PricingPlansPanel;
